import React from 'react';
import WaitlistForm from './WaitlistForm';

const WaitlistSection = () => {
  return (
    <section id="waitlist" className="section-padding bg-gradient-to-br from-primary-600 to-secondary-600 text-white">
      <div className="container-max">
        <div className="text-center max-w-4xl mx-auto">
          {/* Section Header */}
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Be the First to Experience
            <span className="block"> AkiMoon</span>
          </h2>
          <p className="text-xl mb-8 text-primary-100 leading-relaxed">
            Join our exclusive waitlist and get early access to the future of women's health. 
            Plus, receive special launch discounts and insider updates.
          </p>

          {/* Benefits */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <svg className="w-12 h-12 text-white mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <h3 className="font-semibold mb-2">Early Access</h3>
              <p className="text-primary-100 text-sm">
                Be among the first to try AkiMoon when we launch
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <svg className="w-12 h-12 text-white mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <h3 className="font-semibold mb-2">Launch Discount</h3>
              <p className="text-primary-100 text-sm">
                Get 50% off your first 3 months of Premium
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <svg className="w-12 h-12 text-white mx-auto mb-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              <h3 className="font-semibold mb-2">Exclusive Updates</h3>
              <p className="text-primary-100 text-sm">
                Behind-the-scenes insights and feature previews
              </p>
            </div>
          </div>

          {/* Waitlist Form */}
          <div className="mb-8">
            <WaitlistForm />
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-primary-100">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>No spam, ever</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Unsubscribe anytime</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 text-green-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Privacy protected</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-10 left-10 w-16 h-16 bg-white/10 rounded-full animate-pulse-slow"></div>
      <div className="absolute bottom-10 right-10 w-24 h-24 bg-white/10 rounded-full animate-pulse-slow" style={{animationDelay: '0.5s'}}></div>
      <div className="absolute top-1/2 left-1/3 w-12 h-12 bg-white/10 rounded-full animate-pulse-slow" style={{animationDelay: '1s'}}></div>
    </section>
  );
};

export default WaitlistSection; 